<template>
  <nuxt-link
    tag="div"
    :to="
      localePath({
        name: 'location-trainer-id',
        params: { id: tr.url, location: city }
      })
    "
    class="trainer-card"
  >
    <div class="card-header">
      <p class="name">{{ fullName }}</p>
      <LikesBlock :rating="tr.rating" />
    </div>
    <div class="card-container">
      <div class="avatar-block">
        <img :src="imgURL" alt="trainer-avatar" />
        <LikesBlock :rating="tr.rating" />
      </div>
      <div class="information-block">
        <p class="name">
          {{ fullName }}
        </p>
        <p v-for="el in sports" :key="el.id" class="sport-type">
          <img :src="sportIcon(el.id)" :alt="`sport${el.id}`" />
          <span class="exp-block">
            <span class="value">{{ el.value }}</span>
            <span class="exp"
              >- {{ $t('common.trainer_exp') }}
              {{ expDate(el.pivot.experience_since) }}
            </span>
          </span>
        </p>
      </div>
    </div>
  </nuxt-link>
</template>

<script>
import { mapGetters } from 'vuex'
import LikesBlock from '@/components/Trainer/LikesBlock'
export default {
  name: 'TrainerCardItem',
  components: {
    LikesBlock
  },
  props: {
    tr: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      city: 'location/getUrlKey'
    }),
    imgURL() {
      return this.tr?.fullPathAvatar
        ? this.tr?.fullPathAvatar
        : require('~/assets/img/no-avatar-icon.png')
    },
    fullName() {
      return `${this.tr.first_name} ${this.tr.last_name}`
    },
    sports() {
      return this.tr?.sportsWithOutdoors
    }
  },
  methods: {
    sportIcon(_id) {
      try {
        return require(`~/assets/img/sports/small/${_id}.png`)
      } catch (e) {
        return require(`~/assets/img/sports/small/null.png`)
      }
    },
    expDate(_date) {
      return this.$moment(_date).toNow(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.trainer-card {
  line-height: normal;
  border-bottom: 1px solid #f3f3f3;
  padding: 10px;

  .card-header {
    display: none;
  }

  &:last-child {
    border-bottom: none;
  }

  .card-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .avatar-block {
    width: 25%;
    margin-right: 12px;

    img {
      border-radius: 2px;
    }
  }

  .information-block {
    width: 74%;

    .name {
      font-size: 16px;
      margin-bottom: 12px;
    }

    .sport-type {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      margin-bottom: 9px;
      line-height: 1.3;

      .exp-block {
        display: flex;
        flex-wrap: wrap;

        .value {
          margin-right: 5px;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      img {
        width: 7%;
        margin-right: 8px;
      }

      .exp {
        color: $gray;
      }
    }
  }
}
@media (min-width: 1024px) {
  .trainer-card {
    padding: 0;
    border-bottom: none;
    background-color: transparent;
    width: 48%;
    margin-bottom: 20px;

    &:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }

    &:hover {
      cursor: pointer;

      .card-container {
        box-shadow: 1px 5px 8px -3px rgba(0, 0, 0, 0.6);
        transition: 0.2s ease;
      }
    }

    .card-container {
      width: 100%;
      border-radius: 3px;
      overflow: hidden;
      transition: 0.2s ease;
      position: relative;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 5px;

      .likes-block {
        height: auto;
        margin-bottom: 0;
        width: auto;
        line-height: 1.1;
      }

      .name {
        font-size: 18px;
        color: $primary;
      }
    }

    .information-block {
      padding: 5px 5px 5px 10px;
      width: 100%;
      background-color: $gray-lighter;
      border: 1px solid #f0f0f0;
      border-bottom-right-radius: 3px;
      border-top-right-radius: 3px;

      .name {
        display: none;
      }

      .sport-type {
        font-size: 13px;
      }
    }
    .avatar-block {
      margin-right: 0;
      max-width: 120px;
      width: 100%;
      height: 120px;

      img {
        border-radius: unset;
      }

      .likes-block {
        display: none;
      }
    }
  }
}
</style>
